import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  isLoadingSubject = new BehaviorSubject<boolean>(false);
  private requestMap: Map<string, boolean> = new Map<string, boolean>();

  constructor() { }

  setRequest(loading: boolean, url: string): void {
    if (!url) {
      throw new Error('The request URL must be provided.');
    }
    if (loading === true) {
      this.requestMap.set(url, loading);
      this.isLoadingSubject.next(true);
    } else if (loading === false && this.requestMap.has(url)) {
      this.requestMap.delete(url);
    }
    if (this.requestMap.size === 0) {
      this.isLoadingSubject.next(false);
    }
  }
}
